<template>
  <div class="tableDoc">
    <adx-table text="Tooltip button" :items="data1" @selected="selected" @setItem="setItem">
      <span slot="content" class="btn-plus">
        <i class="adx-ic_plus"></i>
      </span>
    </adx-table>
    <adx-table text="Tooltip button" :items="data2" 
    @selected="selected" @setItem="setItem" @selectedAction="selectedAction" @selectedInput="selectedInput">
      <span slot="content" class="btn-plus">
        <i class="adx-ic_plus"></i>
      </span>
    </adx-table>
    <adx-table text="Tooltip button" :items="data3" :dropdownItems="optionList" 
    @selected="selected" @setItem="setItem" @selectedAction="selectedAction" @selectedInput="selectedInput" @selectedDropdown="selectedDropdown">
      <span slot="content" class="btn-plus">
        <i class="adx-ic_plus"></i>
      </span>
    </adx-table>
  </div>
</template>

<script>
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'

export default {
  name: "adx-table-doc",
  components: {
    "adx-table": table,
    LabelStatus
  },
  props: {
      
  },
  data() {
    return {
      item: null,
      optionList: [
        {
          'id': 0,
          'label': 'Select',
          'value': '',
        },
        {
          'id': 1,
          'label': 'Name 1',
          'value': '1',
        },
        {
          'id': 2,
          'label': 'Name 2',
          'value': '2',
        },
        {
          'id': 3,
          'label': 'Name 3',
          'value': '3',
        },
      ],
      data1: {
        notifications: [
          { type: "new" },
          { type: "warning" },
          { type: "warning" }
        ],
        checkbox: true,
        menu: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": [
            {
              'label': 'Designing Approval',
              'value': 'designing'
            },
            {
              'label': 'Verifying',
              'value': 'verifying'
            },
            {
              'label': 'Validating',
              'value': 'validating'
            },
            {
              'label': 'Wrapping',
              'value': 'wrapping'
            },
            {
              'label': 'Done',
              'value': 'done'
            },
          ]
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        },
      ],
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PROGRESS",
            type: "statuslabel"
          },
          {
            title: "STATUS",
            type: "indicatorStatus"
          },
          {
            title: "START DATE",
            type: "date"
          },
          {
            title: "PERIOD",
            type: "period"
          }
        ],
        body: [
          {
            values: [
              { value: "id" },
              { value: "campaign1" },
              { value: "upcoming", label: "Upcoming" },
              { status: "verified", items:[
                  {
                    'status': false,
                    'title': 'VERIFIED',
                  },
                  {
                    'status': false,
                    'title': 'DESIGNED',
                  },
                  {
                    'status': false,
                    'title': 'WRAPPED',
                  }
                ]
              },
              { value: "2018-12-10" },
              { start: "", end: "" },
            ]
          },
          {
            values: [
              { value: "id2" },
              { value: "campaign2" },
              { value: "active", label: "Active" },
              { status: "designed", items:[
                  {
                    'status': false,
                    'title': 'VERIFIED',
                  },
                  {
                    'status': false,
                    'title': 'DESIGNED',
                  },
                  {
                    'status': false,
                    'title': 'WRAPPED',
                  }
                ]
              },
              { value: "" },
              { start: "2018-07-09", end: "2018-12-10" },
            ]
          },
          {
            values: [
              { value: "id3" },
              { value: "campaign2" },
              { value: "designing", label: "Design Approval" },
              { status: "", items:[
                  {
                    'status': false,
                    'title': 'VERIFIED',
                  },
                  {
                    'status': false,
                    'title': 'DESIGNED',
                  },
                  {
                    'status': false,
                    'title': 'WRAPPED',
                  }
                ]
              },
              { value: "2018-11-12" },
              { start: "2018-11-01", end: "2018-12-12" },
            ]
          }
        ]
      },
      data2: {
        checkbox: false,
        menu: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": [
            {
              'label': 'Designing',
              'value': 'designing'
            },
            {
              'label': 'Verifying',
              'value': 'verifying'
            },
            {
              'label': 'Validating',
              'value': 'validating'
            },
            {
              'label': 'Wrapping',
              'value': 'wrapping'
            },
            {
              'label': 'Done',
              'value': 'done'
            },
          ]
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        },
      ],
        head: [
          {
            title: "id",
            type: "text"
          },
          {
            title: "Description",
            type: "description"
          },
          {
            title: "Price",
            type: "money"
          },
          {
            title: "Multiple Money",
            type: "multiplemoney"
          },
          {
            title: "Multiple Number",
            type: "multiplenumber"
          },
          {
            title: "Multiple Text",
            type: "multipletext"
          },
        ],
        body: [
          {
            values: [
              { value: "id2" },
              { header: true, items:[
                  {
                    value: "Ambil langkah pertama beriklan"
                  }
                ]
              },
              { value: 18000 },
              { items:[
                  {
                    value: 200000
                  },
                  {
                    value: 40000
                  }
                ]
              },
              { items:[
                  {
                    value: 100
                  },
                  {
                    value: 200
                  }
                ]
              },
              { items: [
                  {
                    value: "Objective : Click to WhatsApp"
                  },
                  {
                    value: "Platform : Instagram, Facebook"
                  },
                ]
              }
            ]
          },
          {
            values: [
              { value: "id3" },
              { header: true, items:[
                  {
                    value: "Langkah Pertama Untuk Beriklan"
                  },
                  {
                    value: "Ambil langkah pertama beriklan"
                  }
                ]
              },
              { value: 290000 },
              { items:[
                  {
                    value: 250000
                  },
                  {
                    value: 30000
                  }
                ]
              },
              { items:[
                  {
                    value: 10000
                  },
                  {
                    value: 2500
                  }
                ]
              },
              { items: [
                  {
                    value: "Objective : Click to WhatsApp"
                  },
                  {
                    value: "Platform : Instagram, Facebook"
                  },
                ]
              }
            ]
          },
          {
            values: [
              { value: "id4" },
              { header: true, items:[
                  {
                    value: "Langkah Pertama Untuk Beriklan"
                  }
                ]
              }, 
              { value: 100000 },
              { items:[
                  {
                    value: 200000
                  },
                  {
                    value: 40000
                  }
                ]
              },
              { items:[
                  {
                    value: 10
                  },
                  {
                    value: 200
                  }
                ]
              },
              { items: [
                  {
                    value: "Objective : Click to WhatsApp"
                  },
                  {
                    value: "Platform : Instagram, Facebook"
                  },
                ]
              }
            ]
          }
        ]
      },
      data3: {
        checkbox: false,
        menu: [],
        head: [
          {
            title: "id",
            type: "text",
            display: "display:none;"
          },
          {
            title: "Image",
            type: "image"
          },
          {
            title: "Name",
            type: "input"
          },
          {
            title: "Dropdown",
            type: "dropdown"
          },
          {
            title: "Status",
            type: "multipletext"
          },
          {
            title: "Icon from Img",
            type: "icon"
          },
          {
            title: "Icon",
            type: "icon"
          },
          {
            title: "Icon from Img",
            type: "icon"
          },
          {
            title: "Disabled",
            type: "icon"
          },
          {
            title: "Check",
            type: "checked"
          }
        ],
        body: [
          {
            values: [
              { value: "id2", display: "display:none;" },
              { value: "/img/notfound/img-placeholder_square.jpg" },
              { value: "" },
              { value: "" },
              { items: [
                  {
                    statuses: [
                      { value: "yes", label: "Konsultasi" },
                      { value: "no", label: "Laporan" },
                      { value: "no", label: "Optimasi" },
                    ]
                  }
                ]
              },
              { imgIcon: "/img/ic-eyes.svg", text: "Tooltext"},
              { icon: "icon-eye", text: "Tooltext", isDisabled: false},
              { icon: "icon-edit", text: "Tooltext", isDisabled: true},
              { value: true },
            ]
          },
          {
            values: [
              { value: "id3", display: "display:none;" },
              { value: "/img/notfound/img-placeholder_square.jpg" },
              { value: "ID 67756" },
              { value: "1" },
              { items: [
                  {
                    statuses: [
                      { value: "yes", label: "Konsultasi" },
                      { value: "no", label: "Laporan" },
                      { value: "no", label: "Optimasi" },
                    ]
                  }
                ]
              },
              { imgIcon: "/img/ic-eyes.svg", text: "Tooltext"},
              { icon: "icon-eye", text: "Tooltext", isDisabled: false},
              { icon: "icon-edit", text: "Tooltext", isDisabled: true},
              { value: true },
            ]
          },
          {
            values: [
              { value: "id4", display: "display:none;" },
              { value: "/img/notfound/img-placeholder_square.jpg" },
              { value: "ID 6777678" },
              { value: "2" },
              { items: [
                  {
                    statuses: [
                      { value: "yes", label: "Konsultasi" },
                      { value: "no", label: "Laporan" },
                      { value: "no", label: "Optimasi" },
                    ]
                  }
                ]
              },
              { imgIcon: "/img/ic-eyes.svg", text: "Tooltext"},
              { icon: "icon-eye", text: "Tooltext", isDisabled: false},
              { icon: "icon-edit", text: "Tooltext", isDisabled: true},
              { value: true },
            ]
          }
        ]
      },
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
      selected(event) {
        if (event.value == 'add') {
          this.data.body.push(
            {
              values: [
                { value: "id99" },
                { value: "company name2" },
                { value: "campaign name2" },
                { value: "progress2" },
                { value: "status2" },
                { value: 100000 },
                { value: "start date2" },
              ]
            }
          )
        } else if (event.value == 'remove') {
          for (var i=0; i<this.data.body.length; i++) {
            if (this.data.body[i] == this.item) {
              this.data.body.splice(i, 1)
              break
            }
          }
        }
      },
      setItem(item) {
        this.item = item
      },
      selectedAction(id, type){
        if(type == 'icon-edit'){
          this.$router.push({name: 'home'})
        }else if(type == 'icon-eye'){
          this.$router.push({name: 'admin'})
        }
      },
      selectedInput(index, item, value){
        console.log(index, item.values[0].value, value)
      },
      selectedDropdown(value, item){
        console.log(value, item)
        // console.log(index, item.values[0].value, value)
      }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
